'use client'

import {
    Toaster as ChakraToaster,
    Portal,
    Spinner,
    Stack,
    Toast,
    createToaster,
} from '@chakra-ui/react'
import { lang } from '@src/lang'

export enum ToastType {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
}

export const toaster = createToaster({
    placement: 'bottom-end',
    pauseOnPageIdle: true,
    max: 5,
})

export const Toaster = () => {
    return (
        <Portal>
            <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
                {toast => (
                    <Toast.Root width={{ md: 'sm' }}>
                        {toast.type === 'loading' ? (
                            <Spinner size="sm" color="blue.solid" />
                        ) : (
                            <Toast.Indicator />
                        )}
                        <Stack gap="1" flex="1" maxWidth="100%">
                            {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
                            {toast.description && (
                                <Toast.Description>{toast.description}</Toast.Description>
                            )}
                        </Stack>
                        {toast.action && (
                            <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
                        )}
                        {toast.closable && <Toast.CloseTrigger />}
                    </Toast.Root>
                )}
            </ChakraToaster>
        </Portal>
    )
}

export const toast = (type: ToastType, titleMessage?: string, description?: string) => {
    let title = ''
    switch (type) {
        case ToastType.SUCCESS:
            title = lang.completed
            break
        case ToastType.ERROR:
            title = lang.error
            break
    }

    if (titleMessage) {
        title = `${title}: ${titleMessage}`
    }

    toaster.create({ type, title, description, closable: true })
}
